var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZalo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .042h7.115V8.95H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.026.058H2.01v9.716H.026z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#FFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 15.755)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.674 7.072c1.19 0 2.302-.007 3.413.003.624.006.962.28 1.019.788.073.643-.29 1.07-.965 1.078-1.272.015-2.544.005-3.815.005-.368 0-.736.014-1.102-.008-.456-.027-.902-.12-1.12-.607-.22-.488-.067-.925.235-1.322l3.648-4.79c.072-.094.142-.191.212-.286-.074-.139-.192-.076-.283-.077-.853-.006-1.705 0-2.557-.006a2.322 2.322 0 0 1-.583-.069.84.84 0 0 1-.639-.824A.841.841 0 0 1 .761.12c.187-.054.388-.073.583-.074C2.747.041 4.15.041 5.553.046c.248 0 .498.007.738.093.532.19.766.696.55 1.233-.188.467-.488.864-.788 1.258-1.029 1.353-2.061 2.702-3.092 4.053-.08.105-.157.212-.287.39",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.02 21.52c.008.28.097.656.331.982.51.71 1.554.708 2.063-.001.441-.615.44-1.635-.002-2.249a1.186 1.186 0 0 0-.934-.518c-.863-.052-1.467.637-1.458 1.786m2.782-2.972c.191-.25.381-.484.705-.552.619-.13 1.205.284 1.213.934.02 1.625.013 3.25.004 4.875a.956.956 0 0 1-.655.92c-.405.143-.828.04-1.1-.314-.132-.173-.189-.203-.374-.048-.716.6-1.524.705-2.398.413-1.402-.47-1.978-1.599-2.13-2.98-.164-1.485.314-2.759 1.6-3.54 1.068-.648 2.152-.594 3.135.292M27.234 21.369c-.002.416.092.804.335 1.141a1.267 1.267 0 0 0 2.04.015c.457-.614.459-1.659.007-2.28a1.185 1.185 0 0 0-.936-.512c-.85-.046-1.443.625-1.446 1.636m-1.979.196c-.06-2.088 1.266-3.647 3.15-3.707 2.004-.064 3.474 1.328 3.534 3.357.06 2.055-1.16 3.512-3.04 3.707-2.044.212-3.673-1.327-3.644-3.357"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.557 15.023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.008 4.926c0 1.26.006 2.519-.002 3.778C2 9.424 1.386 9.912.724 9.74.327 9.636.03 9.2.03 8.693.026 6.539.028 4.386.028 2.233c0-.38-.005-.759.001-1.138C.04.47.425.065 1.004.058 1.6.052 2.002.46 2.006 1.107c.008 1.273.002 2.546.002 3.819",
    mask: "url(#d)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZalo);
export default __webpack_public_path__ + "static/media/zalo.876174c18d4c83997f04c906dabbeadb.svg";
export { ForwardRef as ReactComponent };